// extracted by mini-css-extract-plugin
export default {"root":"Fade_root-dcz","fadeIn":"Fade_fadeIn-ChY"};